import Api from "api";
import { ActivityLogModel } from "models/RevenueManagement/Card/ActivityLogModel";

export const getActivitiesLogsService = async (): Promise<
  ActivityLogModel[]
> => {
  return await Api.get("activitieslogs").then(({ data }) => data);
};
